module.exports = __webpack_public_path__ + "img/sdb.21872c34.jpeg";